// extracted by mini-css-extract-plugin
module.exports = {"footer-disclaimer":"footer-disclaimer--2mxts"};